import React from "react";
import logo1 from "../../assets/img/logos/DLogic.webp";
import logo2 from "../../assets/img/logos/evate.jpeg";
import logo3 from "../../assets/img/logos/frhsi-logo.png";
import logo4 from "../../assets/img/logos/renderInfotech.png";
import logo5 from "../../assets/img/logos/bvk-logo.png";

const LogoStrip = () => {
    return (
        <div className="logo-strip-container">
            <div className="logo-track">
                {/* First Set */}
                <img src={logo1} alt="Partner Logo" className="logo-img" />
                <img src={logo2} alt="Partner Logo" className="logo-img" />
                <img src={logo3} alt="Partner Logo" className="logo-img" />
                <img src={logo4} alt="Partner Logo" className="logo-img" />
                <img src={logo5} alt="Partner Logo" className="logo-img" />
                <img src={logo1} alt="Partner Logo" className="logo-img" />
                <img src={logo2} alt="Partner Logo" className="logo-img" />
                <img src={logo3} alt="Partner Logo" className="logo-img" />
                <img src={logo4} alt="Partner Logo" className="logo-img" />
                <img src={logo5} alt="Partner Logo" className="logo-img" />

                {/* Duplicate Set for seamless loop */}
                <img src={logo1} alt="Partner Logo" className="logo-img" />
                <img src={logo2} alt="Partner Logo" className="logo-img" />
                <img src={logo3} alt="Partner Logo" className="logo-img" />
                <img src={logo4} alt="Partner Logo" className="logo-img" />
                <img src={logo5} alt="Partner Logo" className="logo-img" />
                <img src={logo1} alt="Partner Logo" className="logo-img" />
                <img src={logo2} alt="Partner Logo" className="logo-img" />
                <img src={logo3} alt="Partner Logo" className="logo-img" />
                <img src={logo4} alt="Partner Logo" className="logo-img" />
                <img src={logo5} alt="Partner Logo" className="logo-img" />
            </div>
        </div>
    );
};

export default LogoStrip;
